<div class="card">
    <div class="card_header">
        <div class="row row_jc_space_btw">
            <div class="flex_title">
                <p class="title fz_l fw_700">{{title}}</p>
            </div>
            <div class="flex_title row btns">
                <button [class.active]="chartType === 'line'" (click)="changeChartType('line')"
                    class="fz_s btn color_text_gray">
                    <span class="material-symbols-outlined icon row fz_m">
                        timeline
                    </span>
                </button>
                <button [class.active]="chartType === 'bar'" (click)="changeChartType('bar')"
                    class="fz_s btn color_text_gray">
                    <span class="material-symbols-outlined icon row fz_m">
                        bar_chart
                    </span>
                </button>
            </div>
            <div class="flex_title row btns">
                <button class="fz_s btn color_text_gray" *ngFor="let range of timeRanges" (click)="onTimeRangeChange(range)"
                    [class.active]="selectedTimeRange === range">
                    {{ range }}
                </button>
            </div>
        </div>
    </div>
    <div class="card_body">
        <div class="chart_container">
            <canvas id="chart" class="chart"></canvas>
        </div>
    
    </div>
</div>